function BookingReservations() {
    return (
      <>
        <div className="font-bold text-lg mb-16">BookingReservations</div>
      </>
    );
  }
  
  export default BookingReservations;